import { render } from "./lipo.vue?vue&type=template&id=6e532674"
import script from "./lipo.vue?vue&type=script&lang=js"
export * from "./lipo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/arair-kiosk-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__